<div class="relative">
  <!-- Trigger -->
  <button
    type="button"
    (click)="toggle()"
    class="w-full flex items-center gap-1.5 flex-wrap min-h-11 px-3 py-2 border rounded-lg bg-white cursor-pointer transition-colors text-left"
    [ngClass]="
      open()
        ? 'border-accent-500 ring-2 ring-accent-200'
        : error() && selected().length === 0
          ? 'border-red-400 ring-2 ring-red-100'
          : 'border-surface-400'
    "
  >
    @if (visibleChips().length === 0) {
      <span class="text-xs text-slate-400 flex-1">{{ placeholder() }}</span>
    } @else {
      @for (chip of visibleChips(); track chip.id) {
        <span
          class="inline-flex items-center gap-1 pl-2.5 pr-1.5 py-1 bg-slate-100 text-xs text-navy-900 rounded-full whitespace-nowrap"
        >
          {{ chip.label }}
          <button
            type="button"
            (click)="$event.stopPropagation(); deselect(chip.id)"
            class="w-3.5 h-3.5 flex items-center justify-center rounded-full hover:bg-slate-300 transition-colors cursor-pointer shrink-0"
          >
            <img src="/icons/x-icon.svg" class="w-2.5 h-2.5" alt="Remove" />
          </button>
        </span>
      }
      @if (overflowCount() > 0) {
        <span class="px-2.5 py-1 bg-slate-100 text-xs text-navy-900 rounded-full"
          >+{{ overflowCount() }}</span
        >
      }
    }
    <img
      src="/icons/chevron-down-icon.svg"
      class="w-4 h-4 shrink-0 ml-auto opacity-40 transition-transform duration-150"
      [ngClass]="open() ? 'rotate-180' : ''"
      alt=""
    />
  </button>

  <!-- Dropdown panel — fixed so it escapes overflow containers -->
  @if (open()) {
    <div
      class="fixed z-200 bg-white rounded-xl border border-slate-200 shadow-lg overflow-hidden flex flex-col"
      [style.max-height.px]="dropdownMaxHeight()"
      [style.top.px]="openUpward() ? null : dropdownTop()"
      [style.bottom.px]="openUpward() ? dropdownBottom() : null"
      [style.left.px]="dropdownLeft()"
      [style.width.px]="dropdownWidth()"
    >
      <!-- Search -->
      <div class="px-3 py-2.5 border-b border-slate-100 shrink-0">
        <div class="relative">
          <img
            src="/icons/search-icon.svg"
            class="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 opacity-40 pointer-events-none"
            alt=""
          />
          <input
            type="text"
            placeholder="Search…"
            [value]="search()"
            (input)="search.set($any($event.target).value)"
            class="w-full pl-8 pr-3 py-1.5 text-xs border border-slate-200 rounded-lg focus:outline-none focus:border-accent-400 focus:ring-1 focus:ring-accent-200"
            (click)="$event.stopPropagation()"
          />
        </div>
        @if (selected().length > 0) {
          <div class="flex items-center justify-between mt-2 px-0.5">
            <span class="text-2xs text-slate-400">{{ selected().length }} selected</span>
            <button
              type="button"
              (click)="clearAll(); $event.stopPropagation()"
              class="text-2xs font-semibold text-accent-500 hover:text-primary-600 transition-colors cursor-pointer"
            >
              Clear all
            </button>
          </div>
        }
      </div>

      <!-- Options list -->
      <div class="overflow-y-auto max-h-52 min-h-0">
        @for (opt of filtered(); track opt.id) {
          <button
            type="button"
            (click)="toggleOption(opt.id); $event.stopPropagation()"
            class="w-full flex items-center gap-3 px-3 py-2.5 text-xs cursor-pointer transition-colors hover:bg-slate-50 text-left"
          >
            <div
              class="w-4 h-4 rounded flex items-center justify-center shrink-0 border-2 transition-colors"
              [ngClass]="
                isSelected(opt.id) ? 'bg-accent-500 border-accent-500' : 'bg-white border-slate-300'
              "
            >
              @if (isSelected(opt.id)) {
                <img src="/icons/check-white-icon.svg" class="w-2.5 h-2.5" alt="" />
              }
            </div>
            <span [ngClass]="isSelected(opt.id) ? 'text-navy-900 font-medium' : 'text-slate-600'">
              {{ opt.label }}
            </span>
          </button>
        }
        @if (filtered().length === 0) {
          <div class="px-4 py-3 text-xs text-slate-400">No results found</div>
        }
      </div>
    </div>
  }
</div>
